<!----
    Author: hjlee
    Description:
        사용자 선택 모달
---->
<template>
  <b-modal
    id="modal"
    ref="modalRef"
    :title="$t('auth.title.choose_name')"
    :ok-title="$t('common.button.ok')"
    :cancel-title="$t('common.button.cancel')"
    :ok-disabled="!selectedName"
    @ok="confirm"
  >
    <div v-for="(name, nameIndex) in names" :key="'name-for-signin-' + nameIndex" class="name-for-signin">
      <input :id="'name-for-signin-' + nameIndex" v-model="selectedName" type="radio" :value="name" name="name_for_signin">
      <label :for="'name-for-signin-' + nameIndex">{{ name }}</label>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    userId: {
      type: String,
      required: true
    },
    userPwd: {
      type: String,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      names: [],
      selectedName: ''
    }
  },
  methods: {
    showModalAndLoad() {
      this.selectedName = ''
      this.loadNames()
      this.showModal('modalRef')
    },
    loadNames() {
      this.$axios
        .$get('auth/public/getNames?userId=' + this.userId)
        .then(response => {
          if (response.resultCode === 'success') {
            this.names = response.data
            this.$forceUpdate()
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
    },
    confirm(evt) {
      if (this.action === 'login') {
        this.confirmLogin(evt)
      } else {
        this.confirmFindPassword(evt)
      }
    },
    confirmFindPassword(evt) {
      this.$axios
        .$post('/auth/public/findPassword', {
          userId: this.userId,
          nm: this.selectedName,
          locale: localStorage.locale
        })
        .then(response => {
          if (response.resultCode === 'success') {
            this.$toast.info(this.$t(response.message, response.params))
            this.hideModal('modalRef')
          } else {
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
    },
    confirmLogin: function(evt) {
      this.$auth
        .loginWith('jwt', {
          data: {
            userId: this.userId,
            userPwd: this.userPwd,
            nm: this.selectedName,
            siteId: process.env.siteId
          }
        })
        .then(response => {
          if (window._loadedPushToken && window._onPushTokenLoaded) {
            window._onPushTokenLoaded(window._loadedPushToken)
          }

          this.$router.replace('/')
          window._eventHub.$emit('onEndRequest', {
            dont_hide_processing: false,
            url: 'signIn'
          })
        })
        .catch(error => {
          window._eventHub.$emit('onEndRequest', {
            dont_hide_processing: false,
            url: 'signIn'
          })
          if (error.response && error.response.data) {
            if (error.response.data.resultCode === 'password_expired_1') {
              window._eventHub.$emit('showChangePasswordModal', {
                userId: this.userId
              })
            }
          }
        })
    }
  }
}
</script>

<style scoped>
.name-for-signin input {
  display: inline-block;
  min-height: auto !important;
}
.name-for-signin {
  font-size: 1.5rem;
}
</style>
